import { styled } from 'dripsy';
import React from 'react';
import { View, ViewProps } from 'react-native';

const Container = styled(View)((props: IModalViewProps) => ({
  borderRadius: 20,
  backgroundColor: '$background0',
  minWidth: '30%',
  minHeight: '10%',
  maxHeight: props.maxHeight,
  overflow: 'hidden',
}));

export interface IModalViewProps extends ViewProps {
  maxHeight?: number;
}

export function ModalView(props: IModalViewProps) {
  return <Container {...props}>{props.children}</Container>;
}
